import { useState, useEffect } from "react";
import Auth from "../Auth";

export const ClientVersions = () => {
  const [versions, setVersions] = useState(null);
  const loadVersions = async () => {
    const result = await Auth.fetchWithIdToken("/api/clientVersions");
    console.log({ result });
    setVersions(result);
  };

  useEffect(() => {
    const interval = setInterval(loadVersions, 10000);
    loadVersions();
    return () => clearInterval(interval);
  }, []);

  const entries = versions ? Object.entries(versions).sort((a, b) => b[1] - a[1]) : [];

  return (
    <div>
      <h2>Client Versions</h2>
      <table>
        <thead>
          <tr>
            <th style={{ width: "100px" }}>Version</th>
            <th>Last Seen</th>
          </tr>
        </thead>
        <tbody>
          {entries.map(([version, timestamp], index) => {
            const rowStyle = index % 2 === 1 ? { backgroundColor: "var(--menu-color-hover)", lineHeight: "1.5em" } : { lineHeight: "1.5em" };
            return (
              <tr
                key={version}
                style={rowStyle}
              >
                <td style={{ padding: "3px" }}>
                  <strong>{version}</strong>
                </td>
                <td style={{ padding: "3px" }}>{new Date(timestamp).toLocaleString()}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
